// action - account reducer
export const LOGIN = 'auth/LOGIN';
export const LOGOUT = 'auth/LOGOUT';
export const REGISTER = 'auth/REGISTER';
export const SETORGANIZATION = 'auth/SETORGANIZATION';